module.exports = __webpack_public_path__ + "media/images/direct_funding-b68d3e055ddab4921bba906fba5d7f7b.png";